import React, { Component } from "react";
import {
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  Input,
  Badge,
  Alert,
  Spinner,
} from "reactstrap";
import NewSedeModal from "./NewSedeModal";
import ConfirmSedeRemovalModal from "./ConfirmSedeRemovalModal";
import ManageSedeSubcatsModal from "./ManageSedeSubcatsModal";
import Moment from "moment";

class SedeList extends Component {
  state = { currentPage: 1, searchQuery: "" };

  handlePageChange = (page) => this.setState({ currentPage: page });
  handleSearchChange = (e) =>
    this.setState({ searchQuery: e.target.value, currentPage: 1 });

  renderSubcats = (sede) => {

    const subcats = Array.isArray(sede?.subcategories) ? sede.subcategories : [];
    if (!subcats.length) return <span className="text-muted">—</span>;

    const MAX_SHOWN = 4;
    const shown = subcats.slice(0, MAX_SHOWN);
    const remaining = subcats.length - shown.length;

    return (
      <div className="d-flex flex-wrap gap-1">
        {shown.map((s) => (
          <Badge key={s.id ?? `${s.name}-${s.code}`} pill>
            {s.name} {s.code ? `(${s.code})` : ""}
          </Badge>
        ))}
        {remaining > 0 && (
          <Badge
            pill
            title={subcats
              .map((s) => `${s.name}${s.code ? ` (${s.code})` : ""}`)
              .join(", ")}
          >
            +{remaining}
          </Badge>
        )}
      </div>
    );
  };

  render() {
    const { sedes = [], itemsPerPage = 10, loading, error, resetState } = this.props;
    const { currentPage, searchQuery } = this.state;

    if (loading) return <Spinner className="mt-3" />;
    if (error) return <Alert color="danger" className="mt-3">{error}</Alert>;

    const q = (searchQuery || "").trim().toLowerCase();
    const filtered = sedes.filter((s) => {
      const code = (s.sede_code || "").toLowerCase();
      const name = (s.sede || "").toLowerCase();
      return code.includes(q) || name.includes(q);
    });

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = filtered.slice(indexOfFirstItem, indexOfLastItem);
    const totalPagesCalc = Math.ceil(filtered.length / itemsPerPage) || 1;
    const totalPagesMax = 4;
    const totalPages = Math.min(totalPagesCalc, totalPagesMax);

    return (
      <div>
        <Input
          type="text"
          placeholder="Buscar por código o nombre…"
          value={searchQuery}
          onChange={this.handleSearchChange}
          className="mb-3"
        />

        <Table responsive hover striped bordered>
          <thead>
            <tr>
              <th>Value Stream</th>
              <th>ID/PK</th>
              <th>Subcategorías</th>
              <th style={{ width: 320 }}></th>
            </tr>
          </thead>
          <tbody>
            {!sedes.length ? (
              <tr>
                <td colSpan="15" align="center">
                  <b>Ups, todavía no hay sedes.</b>
                </td>
              </tr>
            ) : !currentData.length ? (
              <tr>
                <td colSpan="15" align="center">
                  <b>Sin resultados para “{searchQuery}”.</b>
                </td>
              </tr>
            ) : (
              currentData.map((sede) => (
                <tr key={sede.pk ?? sede.id}>
                  <td>
                    <div className="fw-semibold">{sede.sede}</div>
                  </td>
                  <td>{sede.pk ?? sede.id}</td>
                  <td>{this.renderSubcats(sede)}</td>
                  <td align="center">
                    <NewSedeModal
                      create={false}
                      sede={sede}
                      resetState={resetState}
                    />
                    &nbsp;&nbsp;
                    <ManageSedeSubcatsModal
                      sede={sede}
                      onChanged={resetState}
                    />
                    &nbsp;&nbsp;
                    <ConfirmSedeRemovalModal
                      pk={sede.pk ?? sede.id}
                      resetState={resetState}
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>

        <Pagination size="lg" aria-label="Sede pagination">
          <PaginationItem disabled={currentPage === 1}>
            <PaginationLink previous onClick={() => this.handlePageChange(currentPage - 1)} />
          </PaginationItem>

          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <PaginationItem key={page} active={currentPage === page}>
              <PaginationLink onClick={() => this.handlePageChange(page)}>{page}</PaginationLink>
            </PaginationItem>
          ))}

          <PaginationItem disabled={currentPage === totalPages || totalPages === 0}>
            <PaginationLink next onClick={() => this.handlePageChange(currentPage + 1)} />
          </PaginationItem>
        </Pagination>
      </div>
    );
  }
}

export default SedeList;